/*
  SH Updated: October 2026 - WCAG 4.1.3 Status Messages.
  Level Access manual evaluation #146380: chem-AMP51 + chem-AMP52 (predictive search),
  chem-AMP72 (filtered product count), chem-AMP145, chem-AMP170, chem-AMP171 (contact form messages).
  SH Updated: October 2026 (batch 2) - chem-AMP35 (hotspot open state), chem-AMP41 (Quick View
  aria-expanded removed), chem-AMP92 (cart Remove behaves as a button).

  The status regions themselves are rendered by Liquid, empty, at page load (Level Access's
  stated remediation: the live region must exist before its text changes). This file only
  writes text into them when the page content they describe changes. It does not touch
  theme.js: the stock Impulse code that swaps search results and filtered products is left
  as shipped, and this file watches the containers it fills.

  Regions (all visually hidden, so nothing changes for sighted visitors):
  [data-sh-status-for="<results container id>"]  predictive search, role="status"
  [data-sh-collection-status]                      collection and search result count, role="status"
  [data-sh-contact-status] / [data-sh-contact-alert]  contact form success / errors
*/
(function () {
  if (window.shA11yLiveRegions) return;
  window.shA11yLiveRegions = true;

  // Clear, then set on the next tick, so a screen reader announces a repeat of the same text.
  function say(region, text) {
    if (!region || !text) return;
    region.textContent = '';
    window.setTimeout(function () { region.textContent = text; }, 150);
  }

  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  // 1. Predictive search (AMP51 result counts, AMP52 no results).
  function watchPredictive() {
    var regions = document.querySelectorAll('[data-sh-status-for]');
    Array.prototype.forEach.call(regions, function (region) {
      var container = document.getElementById(region.getAttribute('data-sh-status-for'));
      if (!container) return;
      new MutationObserver(function () {
        var results = container.querySelector('[data-sh-result-count]');
        if (!results) return; // emptied on close: nothing to announce
        var count = parseInt(results.getAttribute('data-sh-result-count'), 10) || 0;
        var terms = results.getAttribute('data-sh-terms') || '';
        if (count === 0) {
          say(region, region.getAttribute('data-sh-none').replace('[terms]', terms));
        } else if (count === 1) {
          say(region, region.getAttribute('data-sh-one'));
        } else {
          say(region, region.getAttribute('data-sh-many').replace('[count]', count));
        }
      }).observe(container, { childList: true });
    });
  }

  // 2. Collection and search grid (AMP72): announce the count after filters or sort re-render.
  function watchCollection() {
    var region = document.querySelector('[data-sh-collection-status]');
    var ajax = document.getElementById('CollectionAjaxContent');
    if (!region || !ajax) return;
    new MutationObserver(function () {
      var count = document.querySelector('.collection-filter__item--count');
      say(region, clean(count && count.textContent));
    }).observe(ajax, { childList: true });
  }

  // 3. Contact form (AMP145, AMP170, AMP171): the message is rendered on the page that loads
  // after the form posts. Text already present at load is not announced, so copy it into the
  // empty region once the page has settled.
  function announceContact() {
    var forms = document.querySelectorAll('[data-sh-contact-status]');
    Array.prototype.forEach.call(forms, function (region) {
      var scope = region.parentNode;
      var success = scope.querySelector('[data-sh-contact-success]');
      var errors = scope.querySelector('.errors');
      var alertRegion = scope.querySelector('[data-sh-contact-alert]');
      if (errors) {
        window.setTimeout(function () { say(alertRegion, clean(errors.textContent)); }, 600);
      } else if (success) {
        window.setTimeout(function () { say(region, clean(success.textContent)); }, 600);
      }
    });
  }

  // 4. Hotspots (AMP35): stock Impulse shows a block by toggling its is-active class and never
  // updates the buttons, so aria-expanded stayed at its first-load value. Mirror the open block.
  function watchHotspots() {
    var sections = document.querySelectorAll('hot-spots');
    Array.prototype.forEach.call(sections, function (el) {
      var buttons = el.querySelectorAll('[data-button][aria-controls]');
      var sync = function () {
        Array.prototype.forEach.call(buttons, function (b) {
          var block = document.getElementById(b.getAttribute('aria-controls'));
          b.setAttribute('aria-expanded', block && block.classList.contains('is-active') ? 'true' : 'false');
        });
      };
      var container = el.querySelector('[data-block-container]');
      if (container) new MutationObserver(sync).observe(container, { attributes: true, attributeFilter: ['class'], subtree: true });
      sync();
    });
  }

  // 5. Quick View buttons (AMP41): they open a dialog, not a section of the page, and Level Access
  // asked for aria-expanded to be removed. Stock Modal code adds it on init and on open; take it off
  // each time. Focus still returns to the button on close (that code does not read the attribute).
  function stripQuickViewExpanded() {
    var strip = function (el) {
      if (el.classList && el.classList.contains('quick-product__btn') && el.hasAttribute('aria-expanded')) {
        el.removeAttribute('aria-expanded');
      }
    };
    Array.prototype.forEach.call(document.querySelectorAll('.quick-product__btn'), strip);
    new MutationObserver(function (records) {
      records.forEach(function (r) { strip(r.target); });
    }).observe(document.body, { attributes: true, attributeFilter: ['aria-expanded'], subtree: true });
  }

  // 6. Links given role="button" (AMP92): a button answers to Space as well as Enter.
  function spaceActivatesRoleButtons() {
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if ((e.key === ' ' || e.key === 'Spacebar') && t && t.hasAttribute && t.hasAttribute('data-sh-role-button')) {
        e.preventDefault();
        t.click();
      }
    });
  }

  function init() {
    watchPredictive();
    watchCollection();
    announceContact();
    watchHotspots();
    stripQuickViewExpanded();
    spaceActivatesRoleButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
